import { $devLog } from '@/utils/devLog';
import { getVisitorSession } from '@/utils/cookieHelpers';
import { EMAIL_CAPTURE } from '@/eventIds';

const eventIdMap = {

}

export default {
  init() {
    if (!window.FS) {
      throw 'Fullstory plugin failed to initialize - Fullstory does not exist';
    }

    const vsCookie = getVisitorSession();
    if (!vsCookie) {
      throw 'Fullstory plugin failed to initialize - vs cookie does not exist';
    }

    FS.identify(vsCookie);
    $devLog('fullstory plugin initialized');
  },

  fireEvent(id, data) {
    fireFullStoryEvent(eventIdMap[id] ?? id, data);
  },

  [EMAIL_CAPTURE](id, email) {
    FS.setUserVars({ email });
  },
}

function fireFullStoryEvent(id, data) {
  $devLog(`Fullstory custom event - ${id} -`, data);
  FS.event(id, data);
}